import React, {
  useCallback,
  useState,
  useEffect,
  useRef,
  useMemo,
} from "react";
import Modal from "react-bootstrap/Modal";
import { pushNotification } from "utils/notifications";
import BanHangApi from "service/QuanLyMuaBan/BanHangApi";
import ThuocTinhGiamTruApi from "service/ThuocTinhGiamTruApi";
import CauHinhTaiSanApi from "service/CauHinhTaiSanApi"; // Nhớ check import
import StoreApi from "service/storeApi";
import TextInputOnRow from "components/GenericComponent/TextInputOnRow";
import DateTimePicker from "components/GenericComponent/DateTimePicker";
import NumberFormat from "react-number-format";
import ReactDropdown from "react-dropdown";
import AsyncSelect from "react-select/async";
import { formatDateV2, convertDate } from "utils/formatDate";
import TableDanhSachTaiSanBan from "./TableDanhSachTaiSanBan";
import { ModalXacNhanItem } from "./ModalXacNhanItem";

const ModalThemSuaBanHang = ({ orderId, onClose }) => {
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const assetFormRef = useRef(null);
  const [ListCauHinhTaiSan, setListCauHinhTaiSan] = useState([]);
  const [ListKho, setListKho] = useState([]);
  const [NgayNhap, setNgayNhap] = useState(new Date());
  const [TenKhachHang, setTenKhachHang] = useState("");
  const [SoDienThoai, setSoDienThoai] = useState("");
  const [DiaChi, setDiaChi] = useState("");
  const [OrderNote, setOrderNote] = useState("");
  const [TotalPaid, setTotalPaid] = useState(0);
  const [ListDanhSachTaiSanMua, setListDanhSachTaiSanMua] = useState([]);
  const [ListTaiSanIdGoc, setListTaiSanIdGoc] = useState([]);
  const [filterLoaiTaiSanId, setFilterLoaiTaiSanId] = useState(0);
  const [filterKhoId, setFilterKhoId] = useState(0);
  const [selectedTaiSan, setSelectedTaiSan] = useState(null);
  const [SoTien, setSoTien] = useState(0);
  const [PhiKhac, setPhiKhac] = useState(0);
  const [GhiChu, setGhiChu] = useState("");
  const [thuocTinhTaiSan, setThuocTinhTaiSan] = useState([]);
  const [listAnh, setListAnh] = useState([]);
  const [editingAssetId, setEditingAssetId] = useState(null);
  const [showConfirmXoaItem, setShowConfirmXoaItem] = useState(false);
  const [deletingAsset, setDeletingAsset] = useState(null);
  const [hinhThucThanhToan, setHinhThucThanhToan] = useState(0);

  // Hàm của bạn: Trả về Promise chứa list cấu hình
  const loadListThuocTinhTaiSanByCauHinhTaiSanId = (CauHinhTaiSanId) => {
    return CauHinhTaiSanApi.GetThuocTinhTaiSanByCauHinhTaiSanId({
      id: CauHinhTaiSanId,
    })
      .then((res) => {
        return (res.data || []).map((item) => ({
          ...item,
          GiaTri: "",
        }));
      })
      .catch((err) => {
        console.error("Lỗi load danh sách thuộc tính:", err);
        return [];
      });
  };

  const mergeConfigAndValues = (configList, valueList) => {
    const merged = configList.map((config) => {
      const match = valueList.find(
        (v) =>
          (v.OptionName || v.MaThuocTinh || v.TenThuocTinh) ===
          config.MaThuocTinh
      );

      return {
        ...config,
        TenThuocTinh: config.ValueThuocTinh,
        GiaTri: match ? match.OptionValue || match.GiaTri : "",
      };
    });
    return merged;
  };

  const loadInitialComboData = () => {
    const promises = [
      StoreApi.comboAll({ storeName: "", storeAddress: "" }),
      ThuocTinhGiamTruApi.danhsachcauhinhtaisan(),
    ];
    return Promise.all(promises).then(([resKho, resTS]) => {
      return {
        khoList: resKho.data || [],
        cauhinhList: resTS.data.List || [],
      };
    });
  };

  const tongTienHang = useMemo(() => {
    return ListDanhSachTaiSanMua.reduce(
      (sum, item) => sum + (item.SoTien || 0) + (item.PhiKhac || 0),
      0
    );
  }, [ListDanhSachTaiSanMua]);

  useEffect(() => {
    const loadEditData = (id, cauhinhList, khoList) => {
      setLoading(true);
      BanHangApi.getChiTietBanHang(id)
        .then((res) => {
          const data = res.data;
          setNgayNhap(convertDate(data.NgayNhap));
          setTenKhachHang(data.TenKhachHang);
          setSoDienThoai(data.SoDienThoai);
          setDiaChi(data.DiaChi);
          setOrderNote(data.OrderNote || "");
          setTotalPaid(data.TotalPaid || 0);
          setHinhThucThanhToan(data.HinhThucThanhToan);
          const assets = (data.DanhSachTaiSan || []).map((ts) => {
            return {
              ...ts,
              localId: Date.now() + Math.random(),
              ThuocTinhTaiSan: ts.ThuocTinhTaiSan || [],
              LoaiTaiSanTen:
                cauhinhList.find((c) => c.CauHinhTaiSanId == ts.LoaiTaiSan)
                  ?.TenHangHoa || "",
              KhoTen:
                khoList.find((k) => k.StoreId == ts.KhoID)?.StoreName || "",
            };
          });
          setListDanhSachTaiSanMua(assets);
          setListTaiSanIdGoc(assets.map((a) => a.TaiSanId));
        })
        .catch((err) => {
          console.error("Lỗi load chi tiết đơn hàng:", err);
          pushNotification("Không thể tải dữ liệu đơn hàng", "error");
          onClose(false);
        })
        .finally(() => {
          setLoading(false);
        });
    };

    setLoading(true);
    loadInitialComboData()
      .then(({ khoList, cauhinhList }) => {
        setListKho(khoList);
        setListCauHinhTaiSan(cauhinhList);

        if (orderId > 0) {
          loadEditData(orderId, cauhinhList, khoList);
        } else {
          if (khoList.length > 0) setFilterKhoId(khoList[0].StoreId);
          if (cauhinhList.length > 0)
            setFilterLoaiTaiSanId(cauhinhList[0].CauHinhTaiSanId);
          setLoading(false);
        }
      })
      .catch((error) => {
        console.error("Lỗi load data ban đầu:", error);
        pushNotification("Không thể tải dữ liệu ban đầu", "error");
        onClose(false);
        setLoading(false);
      });
  }, []);

  const loaiTaiSanOptions = useMemo(() => {
    return ListCauHinhTaiSan.map((ts) => ({
      value: ts.CauHinhTaiSanId,
      label: ts.TenHangHoa,
    }));
  }, [ListCauHinhTaiSan]);

  const khoOptions = useMemo(() => {
    return ListKho.map((kho) => ({
      value: kho.StoreId,
      label: kho.StoreName,
    }));
  }, [ListKho]);

  const timerRef = useRef(null);

  const loadOptions = useCallback(
    (inputValue, callback) => {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
      timerRef.current = setTimeout(() => {
        BanHangApi.getListTaiSanBanHang({
          loaiTaiSanId: filterLoaiTaiSanId,
          khoId: filterKhoId,
          searchText: inputValue,
        })
          .then((res) => {
            if (res.status === 200) {
              callback(res.data);
            } else {
              callback([]);
            }
          })
          .catch((err) => {
            console.error("Lỗi tìm tài sản:", err);
            callback([]);
          });
      }, 1000);
    },
    [filterLoaiTaiSanId, filterKhoId]
  );

  const handleTaiSanChange = (option) => {
    setSelectedTaiSan(option);
    if (option && option.fullData) {
      const asset = option.fullData;
      loadListThuocTinhTaiSanByCauHinhTaiSanId(asset.LoaiTaiSan).then(
        (listCauHinh) => {
          const listValues = asset.ThuocTinhTaiSan || [];
          const mergedAttributes = mergeConfigAndValues(
            listCauHinh,
            listValues
          );
          setThuocTinhTaiSan(mergedAttributes);
          setListAnh(asset.ListAnh || []);
          setFilterLoaiTaiSanId(asset.LoaiTaiSan);
          setFilterKhoId(asset.KhoID);
        }
      );
    } else {
      setThuocTinhTaiSan([]);
      setListAnh([]);
    }
  };

  const onSaveAsset = () => {
    if (!selectedTaiSan) {
      pushNotification("Vui lòng chọn một tài sản", "error");
      return;
    }

    const asset = selectedTaiSan.fullData;

    if (
      !editingAssetId &&
      ListDanhSachTaiSanMua.some((item) => item.TaiSanId === asset.TaiSanId)
    ) {
      pushNotification("Tài sản này đã có trong đơn hàng", "error");
      return;
    }

    const assetData = {
      TaiSanId: asset.TaiSanId,
      localId: editingAssetId || Date.now() + Math.random(),
      TenTaiSan: asset.TenTaiSan,
      LoaiTaiSan: asset.LoaiTaiSan,
      LoaiTaiSanTen:
        loaiTaiSanOptions.find((opt) => opt.value === asset.LoaiTaiSan)
          ?.label || "",
      KhoID: asset.KhoID,
      KhoTen: khoOptions.find((opt) => opt.value === asset.KhoID)?.label || "",
      SoTien: SoTien,
      PhiKhac: PhiKhac,
      GhiChu: GhiChu,
      ThuocTinhTaiSan: thuocTinhTaiSan.map((tt) => ({
        OptionName: tt.MaThuocTinh,
        OptionValue: tt.GiaTri,
        TenThuocTinh: tt.TenThuocTinh,
      })),
      GiaNhap: asset.GiaNhap,
      ListAnh: listAnh,
    };

    if (editingAssetId) {
      setListDanhSachTaiSanMua((prev) =>
        prev.map((item) => (item.localId === editingAssetId ? assetData : item))
      );
    } else {
      setListDanhSachTaiSanMua((prev) => [assetData, ...prev]);
    }

    resetAssetForm();
  };

  const resetAssetForm = () => {
    setSelectedTaiSan(null);
    setSoTien(0);
    setPhiKhac(0);
    setGhiChu("");
    setThuocTinhTaiSan([]);
    setListAnh([]);
    setEditingAssetId(null);
  };

  const handleEditItem = (asset) => {
    if (assetFormRef.current) {
      assetFormRef.current.scrollIntoView({ behavior: "smooth" });
    }

    setEditingAssetId(asset.localId);
    setFilterLoaiTaiSanId(asset.LoaiTaiSan);
    setFilterKhoId(asset.KhoID);
    loadListThuocTinhTaiSanByCauHinhTaiSanId(asset.LoaiTaiSan).then(
      (listCauHinh) => {
        const rawValues =
          asset.ThuocTinhTaiSanDb || asset.ThuocTinhTaiSan || [];
        const mergedAttributes = mergeConfigAndValues(listCauHinh, rawValues);

        setSelectedTaiSan({
          value: asset.TaiSanId,
          label: asset.TenTaiSan,
          fullData: {
            TaiSanId: asset.TaiSanId,
            TenTaiSan: asset.TenTaiSan,
            LoaiTaiSan: asset.LoaiTaiSan,
            KhoID: asset.KhoID,
            ThuocTinhTaiSan: rawValues,
            ListAnh: asset.ListAnh || [],
          },
        });
        setSoTien(asset.SoTien);
        setPhiKhac(asset.PhiKhac);
        setGhiChu(asset.GhiChu);
        setThuocTinhTaiSan(mergedAttributes);
        setListAnh(asset.ListAnh || []);
      }
    );
  };

  const handleDeleteItem = (asset) => {
    if (editingAssetId === asset.localId) {
      resetAssetForm();
    }
    setListDanhSachTaiSanMua((prev) =>
      prev.filter((item) => item.localId !== asset.localId)
    );
  };

  const confirmDeleteAsset = () => {
    if (!deletingAsset) return;
    setListDanhSachTaiSanMua((prev) =>
      prev.filter((item) => item.localId !== deletingAsset.localId)
    );
    setShowConfirmXoaItem(false);
    setDeletingAsset(null);
  };

  const handleSaveOrder = () => {
    if (!TenKhachHang) {
      pushNotification("Vui lòng nhập Tên khách hàng", "error");
      return;
    }
    if (ListDanhSachTaiSanMua.length === 0) {
      pushNotification(
        "Vui lòng thêm ít nhất một tài sản vào đơn hàng",
        "error"
      );
      return;
    }

    setSaving(true);

    const payload = {
      OrderID: orderId,
      NgayNhap: formatDateV2(NgayNhap),
      TenKhachHang: TenKhachHang,
      SoDienThoai: SoDienThoai,
      DiaChi: DiaChi,
      OrderNote: OrderNote,
      TotalPaid: TotalPaid,
      CalculatedTotalAmount: tongTienHang,
      HinhThucThanhToan: hinhThucThanhToan,
      DanhSachTaiSan: ListDanhSachTaiSanMua.map((ts) => ({
        TaiSanId: ts.TaiSanId,
        TenTaiSan: ts.TenTaiSan,
        LoaiTaiSan: ts.LoaiTaiSan,
        KhoID: ts.KhoID,
        SoTien: ts.SoTien,
        PhiKhac: ts.PhiKhac,
        GhiChu: ts.GhiChu,
        ThuocTinhTaiSan: ts.ThuocTinhTaiSan.map((tt) => ({
          OptionName: tt.OptionName || tt.MaThuocTinh,
          OptionValue: tt.OptionValue || tt.GiaTri,
        })),
      })),
    };

    BanHangApi.themSuaBanHang(payload)
      .then((res) => {
        if (res.status === 200) {
          pushNotification(
            res.data.Message || "Lưu đơn hàng thành công",
            "success"
          );
          onClose(true);
        } else {
          pushNotification(res.message || "Lưu thất bại", "error");
        }
      })
      .catch((err) => {
        console.error("Lỗi lưu đơn hàng:", err);
        const errMsg =
          err.response?.data?.Message ||
          err.response?.data ||
          err.message ||
          "Lỗi máy chủ";
        pushNotification(errMsg, "error");
      })
      .finally(() => {
        setSaving(false);
      });
  };

  const asyncSelectStyles = `
        .custom-async-select__control {
            border: 1px solid #ced4da !important;
            box-shadow: none !important;
            min-height: 38px;
            border-radius: 10px !important; 
        }
        .custom-async-select__control--is-focused {
            border-color: #ced4da !important;
            box-shadow: none !important;
        }
        .custom-async-select__menu {
            border: 1px solid #ced4da !important;
            box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
            border-radius: 10px !important;
            margin-top: 0px !important;
            overflow: hidden !important; 
        }
        .custom-async-select__indicator-separator {
            display: none;
        }
        .custom-async-select__menu-list {
            padding-top: 0 !important;
            padding-bottom: 0 !important;
        }
        .custom-async-select__option--is-focused {
            background-color: #056569 !important;
            color: white !important;
            cursor: pointer;
        }
        .custom-async-select__option--is-selected {
            background-color: #056569 !important; 
            color: white !important;
        }
        .custom-async-select__option:active {
            background-color: #056569 !important;
        }
    `;

  return (
    <>
      <style>{asyncSelectStyles}</style>
      <Modal
        show={true}
        size="new-size"
        centered
        className="modal-new modal fade text-left popup-detail"
        animation={true}
        style={{ zIndex: 1050 }}
      >
        <Modal.Header>
          <h4 className="modal-title">
            <span className="btn-icon-right">
              <img
                src="/app-assets/images/logo-quan-ly-mua-ban-nhap-hang-v2.png"
                alt="logo"
                style={{ height: 24 }}
              />
            </span>
            <span style={{ fontWeight: "bold" }}>
              {orderId === 0
                ? "Thêm mới đơn bán hàng"
                : "Sửa thông tin đơn bán hàng"}
            </span>
          </h4>
          <button
            type="button"
            className="close-popup-new"
            onClick={() => onClose(false)}
            disabled={saving}
          >
            <i className="mdi mdi-close"></i>
          </button>
        </Modal.Header>
        <Modal.Body>
          {loading && <div className="loader loader-default is-active"></div>}

          <h3
            className="lead collapsed"
            style={{
              paddingBottom: "5px",
              color: "#00B69B",
              fontWeight: "bold",
            }}
          >
            Thông tin đơn hàng
          </h3>
          <div className="row">
            <div className="col-md-3">
              <div className="form-group">
                <label style={{ fontWeight: "bold" }}>Ngày</label>
                <DateTimePicker
                  id="Time"
                  value={NgayNhap}
                  onChange={setNgayNhap}
                  className="form-control input-sm"
                />
              </div>
            </div>
            <div className="col-md-3">
              <div className="form-group">
                <label style={{ fontWeight: "bold" }}>
                  Tên khách hàng<span className="text-danger">(*)</span>
                </label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Nhập tên khách hàng"
                  value={TenKhachHang}
                  onChange={(e) => setTenKhachHang(e.target.value)}
                />
              </div>
            </div>
            <div className="col-md-3">
              <div className="form-group">
                <label style={{ fontWeight: "bold" }}>Số điện thoại</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Nhập số điện thoại"
                  value={SoDienThoai}
                  onChange={(e) => setSoDienThoai(e.target.value)}
                />
              </div>
            </div>
            <div className="col-md-3">
              <div className="form-group">
                <label style={{ fontWeight: "bold" }}>Địa chỉ </label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Nhập địa chỉ"
                  value={DiaChi}
                  onChange={(e) => setDiaChi(e.target.value)}
                />
              </div>
            </div>
          </div>

          <div ref={assetFormRef}>
            <h3
              className="lead collapsed"
              style={{
                paddingBottom: "5px",
                color: "#00B69B",
                fontWeight: "bold",
              }}
            >
              Tài sản mua
            </h3>

            <div className="row">
              <div className="col-md-4">
                <div className="form-group">
                  <label style={{ fontWeight: "bold" }}>Loại tài sản</label>
                  <ReactDropdown
                    options={loaiTaiSanOptions}
                    onChange={(opt) => setFilterLoaiTaiSanId(opt.value)}
                    value={loaiTaiSanOptions.find(
                      (opt) => opt.value === filterLoaiTaiSanId
                    )}
                    controlClassName="form-control input-sm"
                    disabled={editingAssetId}
                  />
                </div>
              </div>
              <div className="col-md-4">
                <div className="form-group">
                  <label style={{ fontWeight: "bold" }}>Kho</label>
                  <ReactDropdown
                    options={khoOptions}
                    onChange={(opt) => setFilterKhoId(opt.value)}
                    value={khoOptions.find((opt) => opt.value === filterKhoId)}
                    controlClassName="form-control input-sm"
                    disabled={editingAssetId}
                  />
                </div>
              </div>
              <div className="col-md-4">
                <div className="form-group">
                  <label style={{ fontWeight: "bold" }}>
                    Tên tài sản (Tìm kiếm)
                    <span className="text-danger">(*)</span>
                  </label>
                  <AsyncSelect
                    key={`select-taisan-${filterLoaiTaiSanId}-${filterKhoId}`}
                    cacheOptions
                    defaultOptions
                    loadOptions={loadOptions}
                    onChange={handleTaiSanChange}
                    value={selectedTaiSan}
                    placeholder="Gõ để tìm tên, mã, hoặc IMEI..."
                    isDisabled={editingAssetId}
                    classNamePrefix="custom-async-select"
                  />
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-4">
                <div className="form-group">
                  <label style={{ fontWeight: "bold" }}>
                    Số tiền (Giá bán)
                  </label>
                  <NumberFormat
                    className="form-control"
                    placeholder="Nhập giá bán"
                    value={SoTien}
                    thousandSeparator=","
                    onValueChange={(values) =>
                      setSoTien(values.floatValue || 0)
                    }
                  />
                </div>
              </div>
              <div className="col-md-4">
                <div className="form-group">
                  <label style={{ fontWeight: "bold" }}>Phí khác</label>
                  <NumberFormat
                    className="form-control"
                    placeholder="Nhập phí khác"
                    value={PhiKhac}
                    thousandSeparator=","
                    onValueChange={(values) =>
                      setPhiKhac(values.floatValue || 0)
                    }
                  />
                </div>
              </div>
              <div className="col-md-4">
                <div className="form-group">
                  <label style={{ fontWeight: "bold" }}>Tổng tiền</label>
                  <NumberFormat
                    className="form-control"
                    value={(SoTien || 0) + (PhiKhac || 0)}
                    thousandSeparator=","
                    disabled
                  />
                </div>
              </div>
              <div className="col-md-12">
                <div className="form-group">
                  <label style={{ fontWeight: "bold" }}>
                    Ghi chú (cho tài sản này)
                  </label>
                  <textarea
                    className="form-control1 input-sm"
                    placeholder="Nhập nội dung ghi chú cho tài sản"
                    value={GhiChu}
                    onChange={(e) => setGhiChu(e.target.value)}
                    rows={2}
                    style={{ width: "100%" }}
                  ></textarea>
                </div>
              </div>
            </div>

            <h3
              className="lead collapsed"
              style={{
                paddingBottom: "5px",
                color: "#00B69B",
                fontWeight: "bold",
              }}
            >
              Thông tin tài sản
            </h3>
            <div className="row align-items-end">
              {thuocTinhTaiSan.map((item, index) => (
                <div className="col-md-3" key={index}>
                  <TextInputOnRow
                    labelClass="label-control text-bold"
                    inputClass="form-control input-sm"
                    wrapperClass="form-group"
                    labelText={item.TenThuocTinh}
                    inputProps={{
                      value: item.GiaTri,
                      disabled: true,
                    }}
                  ></TextInputOnRow>
                </div>
              ))}
            </div>
            <div className="row">
              <div className="col-md-12">
                {!editingAssetId && selectedTaiSan && (
                  <div className="form-group">
                    <h3
                      className="lead collapsed"
                      style={{
                        paddingBottom: "5px",
                        color: "#00B69B",
                        fontWeight: "bold",
                      }}
                    >
                      Hình ảnh tài sản
                    </h3>
                    <div className="d-flex flex-wrap gap-2">
                      {listAnh.length === 0 && (
                        <span className="text-muted">
                          Không tìm thấy ảnh cho tài sản này.
                        </span>
                      )}
                      {listAnh.map((url, index) => (
                        <img
                          key={index}
                          src={url}
                          alt="Ảnh tài sản"
                          style={{
                            height: 100,
                            width: 100,
                            objectFit: "cover",
                            border: "1px solid #ddd",
                            borderRadius: 4,
                          }}
                        />
                      ))}
                    </div>
                  </div>
                )}
              </div>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                gap: "10px",
              }}
            >
              {editingAssetId && (
                <button className="btn btn-secondary" onClick={resetAssetForm}>
                  Hủy Sửa
                </button>
              )}
              <button
                className="btn"
                onClick={onSaveAsset}
                disabled={saving}
                style={{ background: "#056569", color: "white" }}
              >
                {editingAssetId ? (
                  <>
                    <i className="mdi mdi-check"></i>&nbsp; Cập nhật tài sản
                  </>
                ) : (
                  <>
                    <img src="/app-assets/images/icon-add-v2.png" alt="Add" />
                    &nbsp; Thêm vào danh sách
                  </>
                )}
              </button>
            </div>
          </div>

          <h3
            className="lead collapsed"
            style={{
              paddingBottom: "5px",
              color: "#00B69B",
              fontWeight: "bold",
            }}
          >
            Danh sách tài sản bán
          </h3>
          <TableDanhSachTaiSanBan
            list={ListDanhSachTaiSanMua}
            onEditItem={handleEditItem}
            onDeleteItem={handleDeleteItem}
          />
        </Modal.Body>

        <Modal.Footer>
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-6"></div>
              <div className="col-md-6 d-flex flex-column align-items-end">
                <div
                  className="d-flex align-items-center form-group"
                  style={{ width: 350 }}
                >
                  <label
                    className="mb-0"
                    style={{ width: 200, fontWeight: "bold" }}
                  >
                    Tổng tiền hàng:
                  </label>
                  <NumberFormat
                    className="form-control text-right"
                    value={tongTienHang}
                    thousandSeparator=","
                    disabled
                    style={{ fontWeight: "bold", color: "#00B69B" }}
                  />
                </div>
                <div
                  className="d-flex align-items-center form-group"
                  style={{ width: 350 }}
                >
                  <label
                    className="mb-0"
                    style={{ width: 200, fontWeight: "bold" }}
                  >
                    Thanh toán:
                  </label>
                  <NumberFormat
                    className="form-control text-right"
                    value={TotalPaid}
                    thousandSeparator=","
                    onValueChange={(values) =>
                      setTotalPaid(values.floatValue || 0)
                    }
                    style={{ fontWeight: "bold", color: "#D93400" }}
                  />
                </div>

                <div
                  className="d-flex align-items-center form-group"
                  style={{ width: 350 }}
                >
                  <label
                    className="mb-0"
                    style={{ width: 200, fontWeight: "bold" }}
                  >
                    Hình thức thanh toán:
                  </label>
                  <select
                    name="BeforeAfter"
                    className="form-control input-sm select-v2"
                    onChange={(e) => setHinhThucThanhToan(e.target.value)}
                    value={hinhThucThanhToan}
                  >
                    <option value="0">Tiền mặt</option>
                    <option value="1">Chuyển khoản</option>
                  </select>
                </div>
              </div>
              <div className="col-md-12 text-right mt-2">
                <button
                  className="btn btn-new-main btn-closenew"
                  onClick={() => onClose(false)}
                  disabled={saving}
                >
                  <i className="mdi mdi-close"></i>&nbsp; Đóng
                </button>
                <button
                  className="btn btn-checknew"
                  disabled={
                    saving || loading || ListDanhSachTaiSanMua.length === 0
                  }
                  style={{
                    background: "#056569",
                    color: "white",
                    borderRadius: "6px",
                    fontSize: "15px",
                    textTransform: "none",
                  }}
                  onClick={handleSaveOrder}
                >
                  {saving ? (
                    <>
                      <span className="spinner-border spinner-border-sm"></span>
                      &nbsp; Đang lưu...
                    </>
                  ) : (
                    <>
                      <img src="/app-assets/images/icon-add-v2.png" alt="Lưu" />
                      &nbsp; {orderId === 0 ? "Tạo đơn" : "Cập nhật đơn"}
                    </>
                  )}
                </button>
              </div>
            </div>
          </div>
        </Modal.Footer>
      </Modal>

      {showConfirmXoaItem && (
        <ModalXacNhanItem
          show={showConfirmXoaItem}
          onHide={() => {
            setShowConfirmXoaItem(false);
            setDeletingAsset(null);
          }}
          onConfirm={confirmDeleteAsset}
          title="Xác nhận xóa tài sản"
          message={`Bạn có chắc chắn muốn xóa tài sản "${deletingAsset?.TenTaiSan}" khỏi đơn hàng?`}
        />
      )}
    </>
  );
};

export default ModalThemSuaBanHang;
